@if (mode === 'figure' && figureNode) {
  <div class="flex flex-column cursor-move" draggable="true">
    <div class="flex justify-between items-center">
      <div class="flex items-center">
        <!-- Space for potential future content -->
      </div>

      <div class="flex">
        @if (!captionData?.hasCaption) {
          <button mat-icon-button (click)="addCaption()" matTooltip="Add a caption">
            <mat-icon>notes</mat-icon>
          </button>
        }
        @if (isImageFigure(figureNode)) {
          <button mat-icon-button (click)="uploadImage()" matTooltip="Replace the image">
            <mat-icon svgIcon="figure-replace-figure-image"></mat-icon>
          </button>
        }
        <button mat-icon-button (click)="delete()" matTooltip="Delete">
          <mat-icon>delete</mat-icon>
        </button>
        @if (figureNode.attrs.type !== 'code') {
          <button
            mat-icon-button
            [matMenuTriggerFor]="moreOptions"
            aria-label="Example icon-button with a menu"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #moreOptions="matMenu">
            @if (figureNode.attrs?.orientation === 'portrait') {
              <button
                mat-menu-item
                (click)="orientate('landscape')"
                matTooltip="Switch to landscape in PDF exports"
              >
                <mat-icon>text_rotation_down</mat-icon>
                <span>Switch to landscape</span>
              </button>
            }
            @if (figureNode.attrs?.orientation === 'landscape') {
              <button mat-menu-item (click)="orientate('portrait')" matTooltip="Switch to portrait">
                <mat-icon>text_rotation_none</mat-icon>
                <span>Switch to portrait</span>
              </button>
            }
          </mat-menu>
        }
      </div>
    </div>
  </div>

  @if (isEmptyImageFigure(figureNode)) {
    <div class="image flex justify-center m2">
      @if (figureNode.attrs.src?.length > 0) {
        <img [src]="figureNode.attrs.src" />
      } @else {
        <div class="flex flex-column justify-center max-width-1">
          <div>
            @if (isUploading) {
              <mat-spinner class="mx-auto"></mat-spinner>
            } @else {
              <img class="placeholder" src="assets/sf-icons/figure.svg" />
            }
          </div>
          <button
            (click)="uploadImage()"
            [disabled]="isUploading"
            mat-raised-button
            color="primary"
          >
            Upload an image
          </button>
          <div class="drop-zone h6 m2 p2" [ngClass]="{ 'drop-zone-active': isDropTarget }">
            Drag any svg, gif, jpg, tiff or png onto this area.
          </div>
        </div>
      }
    </div>
  }

  @if (!isEmptyImageFigure(figureNode)) {
    <div
      class="image flex flex-column items-center my2 col-12"
      [ngClass]="{ 'drop-zone-active': isDropTarget }"
    >
      @if (figureNode.attrs?.src) {
        <div class="image-container">
          <img
            class="drop-zone h6 p2"
            [src]="figureNode.attrs.src"
            matTooltip="Preview only"
            [attr.alt]="figureNode.attrs?.decorative ? '' : figureNode.attrs?.alt || null"
            [attr.role]="figureNode.attrs?.decorative ? 'presentation' : null"
          />
          <div class="overlay">
            <div class="flex items-center">
              @if (matchingFile$ | async; as file) {
                @if (
                  (file.dpi && file.dpi < 300) || (!figureNode.attrs?.alt && !figureNode.attrs?.decorative)
                ) {
                  @if (file.dpi && file.dpi >= 96 && file.dpi < 300) {
                    <mat-icon
                      class="ml1 pr2 overlay-text"
                      aria-hidden="true"
                      [matTooltip]="
                        'DPI: ' + file.dpi + ' is suitable for web (96+ DPI) but not suitable for print (300+ DPI)' +
                        (!figureNode.attrs?.alt && !figureNode.attrs?.decorative ? '\nMissing alt text for accessibility. ' : '')
                      "
                      matTooltipClass="issues-tooltip"
                    >
                      info
                    </mat-icon>
                  } @else {
                    <mat-icon
                      class="ml1 mr1 warning"
                      aria-hidden="true"
                      [matTooltip]="
                        (file.dpi && file.dpi < 96 ? 'DPI: ' + file.dpi + ' is not suitable for web (96+ DPI) or print (300+ DPI)\nRe-upload the document with better quality images. ' : '') +
                        (!figureNode.attrs?.alt && !figureNode.attrs?.decorative ? 'Missing alt text for accessibility. ' : '')
                      "
                      matTooltipClass="issues-tooltip"
                    >
                      warning
                    </mat-icon>
                  }
                }
              } @else {
                @if (!figureNode.attrs?.alt && !figureNode.attrs?.decorative) {
                  <mat-icon
                    class="ml1 mr1 warning"
                    aria-hidden="true"
                    matTooltip="Missing alt text for accessibility."
                    matTooltipClass="issues-tooltip"
                  >
                    warning
                  </mat-icon>
                }
              }

              @if (figureNode.attrs?.decorative) {
                <p class="overlay-text px1 m0" matTooltip="This image is marked as decorative.">
                  (Decorative)
                </p>
              } @else if (figureNode.attrs?.alt) {
                @if (matchingFile$ | async; as file) {
                  @if (file.dpi && file.dpi < 300) {
                    <ng-container
                      *ngTemplateOutlet="altTextWithIssues; context: { 
                      text: 'Alt: ' + figureNode.attrs.alt, 
                      tooltip: figureNode.attrs.alt 
                    }"
                    ></ng-container>
                  } @else {
                    <ng-container
                      *ngTemplateOutlet="simpleText; context: { 
                      text: 'Alt: ' + figureNode.attrs.alt, 
                      tooltip: figureNode.attrs.alt 
                    }"
                    ></ng-container>
                  }
                } @else {
                  <ng-container
                    *ngTemplateOutlet="simpleText; context: { 
                    text: 'Alt: ' + figureNode.attrs.alt, 
                    tooltip: figureNode.attrs.alt 
                  }"
                  ></ng-container>
                }
              } @else {
                @if (matchingFile$ | async; as file) {
                  <ng-container
                    *ngTemplateOutlet="problemsDetected; context: { 
                    tooltip: (file.dpi && file.dpi >= 96 && file.dpi < 300 ? 'DPI: ' + file.dpi + ' is suitable for web (96+ DPI) but not suitable for print (300+ DPI)\n' : file.dpi && file.dpi < 96 ? 'DPI: ' + file.dpi + ' is not suitable for web (96+ DPI) or print (300+ DPI)\nRe-upload the document with better quality images.\n' : '') + 'Missing alt text for accessibility.' 
                  }"
                  ></ng-container>
                } @else {
                  <ng-container
                    *ngTemplateOutlet="problemsDetected; context: { 
                    tooltip: 'Missing alt text for accessibility.' 
                  }"
                  ></ng-container>
                }
              }

              <button
                mat-icon-button
                class="overlay-button"
                matTooltip="Edit alt text"
                (click)="openEditDialog()"
              >
                <mat-icon>edit</mat-icon>
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  }

  @if (isEmptyNativeTable(figureNode)) {
    <div class="image flex justify-center m2">
      <div class="flex flex-column justify-center max-width-1">
        <div>
          @if (isUploading) {
            <mat-spinner class="mx-auto"></mat-spinner>
          } @else {
            <img class="placeholder" src="assets/sf-icons/table.svg" />
          }
        </div>
        <span class="info"
          >Upload an <b>image table</b> here instead. It will be listed as a table.</span
        >
        <button (click)="uploadImage()" mat-raised-button color="primary">
          Upload an image instead
        </button>
      </div>
    </div>
  }

  <form action="" class="display-none" enctype="multipart/form-data">
    <input #fileUpload type="file" (change)="onUpload($event)" />
  </form>
} @else {
  <div class="metadata-menu__container">
    <button
      mat-stroked-button
      (click)="openEditDialog()"
      [matTooltip]="buttonTooltip"
      contenteditable="false"
    >
      {{ buttonLabel }}
    </button>
  </div>
}

<!-- Template definitions -->
<ng-template #simpleText let-text="text" let-tooltip="tooltip">
  <p class="overlay-text px1 m0" [matTooltip]="tooltip">
    {{text}}
  </p>
</ng-template>

<ng-template #altTextWithIssues let-text="text" let-tooltip="tooltip">
  <p class="overlay-text px1 m0" [matTooltip]="tooltip" matTooltipClass="issues-tooltip">
    {{text}}
  </p>
</ng-template>

<ng-template #problemsDetected let-tooltip="tooltip">
  <p class="overlay-text px1 m0" [matTooltip]="tooltip" matTooltipClass="issues-tooltip">
    Problems detected
  </p>
</ng-template>
